export const CUSTOMERS_TEXT = Object.freeze({
  common: {
    noName: 'Sin nombre',
    noOptionAvailable: 'Sin opción disponible',
  },
  page: {
    title: 'Clientes',
    subtitle: 'Gestión de clientes y relaciones comerciales.',
    loadingDetail: 'Cargando detalle del cliente...',
    sectionTabsAriaLabel: 'Secciones del cliente',
  },
  actions: {
    common: {
      cancel: 'Cancelar',
      moreActions: 'Más acciones',
      activate: 'Activar',
      disable: 'Deshabilitar',
      delete: 'Eliminar',
      save: 'Guardar',
    },
    header: {
      newCustomer: 'Nuevo',
      importCustomers: 'Importar',
      exportCustomers: 'Exportar',
      syncCustomers: 'Sincronizar',
    },
    table: {
      viewDetail: 'Ver detalle',
      editCustomer: 'Editar cliente',
      sortByCustomer: 'Ordenar por cliente',
      sortBySales: 'Ordenar por negocios',
      sortByIncomeForecast: 'Ordenar por ingresos pronosticados',
      sortByIncomeBilled: 'Ordenar por ingresos facturados',
      goCustomerDetail: 'Ir al detalle del cliente',
      goCustomerSales: 'Ir a negocios del cliente',
      goInvoiceDetail: 'Ir al detalle de la factura',
    },
    toolbar: {
      toggleFilters: 'Filtros',
      search: 'Buscar',
    },
    modal: {
      close: 'Cerrar modal',
      sectionMenuAriaLabel: 'Secciones del formulario',
      deleteCustomer: 'Eliminar cliente',
    },
  },
  metrics: {
    incomeForecast: 'Ingresos pronosticados',
    activeCustomers: 'Clientes activos',
    salesInProgress: 'Negocios en curso',
    latestCustomer: 'Último cliente creado',
    latestCustomerMetaPrefix: 'Fecha de creación:',
    latestCustomerEmpty: '-',
  },
  filters: {
    searchPlaceholder: 'Buscar cliente o empresa',
    statusAllLabel: 'Estado: todos',
    options: {
      statusActive: 'Activo',
      statusInactive: 'Inactivo',
      fileComplete: 'Completo',
      fileIncomplete: 'Incompleto',
    },
    fields: {
      status: {
        label: 'Estado',
        placeholder: 'Selecciona estado',
      },
      size: {
        label: 'Tamaño',
        placeholder: 'Selecciona tamaño',
      },
      type: {
        label: 'Tipo de cliente',
        placeholder: 'Selecciona tipo',
      },
      sector: {
        label: 'Sector',
        placeholder: 'Selecciona sector',
      },
      origin: {
        label: 'Origen',
        placeholder: 'Selecciona origen',
      },
      file: {
        label: 'Expediente',
        placeholder: 'Selecciona expediente',
      },
      area: {
        label: 'Área',
        placeholder: 'Selecciona área',
      },
    },
  },
  table: {
    empty: 'Sin resultados para los filtros seleccionados.',
    loading: 'Cargando clientes...',
    headers: {
      index: '#',
      customer: 'CLIENTE',
      mainContact: 'Contacto principal',
      email: 'Email',
      sales: 'NEGOCIOS',
      incomeForecast: 'INGRESOS PRONOSTICADOS',
      incomeBilled: 'INGRESOS FACTURADOS',
      lastInvoice: 'Última factura',
      status: 'Estado',
    },
    status: {
      active: 'Activo',
      inactive: 'Inactivo',
    },
  },
  confirm: {
    toggleStatus: {
      titleDisable: 'Deshabilitar cliente',
      titleActivate: 'Activar cliente',
      subtitle: 'Este cambio solo actualiza el estado del cliente.',
      messageDisable: (customerName) => `Cliente: ${customerName}. ¿Estás seguro que deseas deshabilitarlo? Esta acción NO eliminará el cliente.`,
      messageActivate: (customerName) => `Cliente: ${customerName}. ¿Estás seguro que deseas activarlo?`,
    },
    delete: {
      title: 'Eliminar cliente',
      subtitle: 'Confirma para continuar con esta operación.',
      message: (customerName) => `Cliente: ${customerName}. ¿Estás seguro que deseas eliminarlo? Esta acción no se puede deshacer.`,
    },
    sync: {
      title: 'Sincronizar saldos de clientes',
      subtitle: 'Esta acción recalcula CxC y CxF de todos tus clientes.',
      message: 'La sincronización revisa todos los planes pendientes de tu cuenta para actualizar los saldos de clientes (CxC y CxF).\n\nEste proceso puede tardar unos minutos según el volumen de información.\n\n¿Deseas iniciar la sincronización ahora?',
      confirm: 'Iniciar sincronización',
    },
  },
  toast: {
    loadCustomerError: 'No fue posible cargar la información del cliente.',
    activateSuccess: 'Cliente activado correctamente.',
    disableSuccess: 'Cliente deshabilitado correctamente.',
    deleteSuccess: 'Cliente eliminado correctamente.',
    actionError: 'No fue posible completar la acción solicitada.',
    createSuccess: 'El cliente ha sido registrado correctamente.',
    createError: 'No fue posible guardar el cliente.',
    updateSuccess: 'El cliente ha sido actualizado correctamente.',
    updateError: 'No fue posible actualizar el cliente.',
    syncStarting: 'Iniciando sincronización de saldos de clientes. Este proceso puede tardar unos minutos.',
    syncSuccess: 'Saldos de clientes sincronizados correctamente.',
    syncError: 'No fue posible sincronizar los saldos de clientes.',
    syncCooldown: (minutes) => `Ya existe una sincronización reciente. Intenta nuevamente en ${minutes} minuto${minutes === 1 ? '' : 's'}.`,
    importPending: 'El flujo de importación de clientes se conectará en el siguiente paso.',
  },
  exports: {
    modal: {
      title: 'Exportar clientes',
      subtitle: 'Selecciona la información que deseas incluir en el archivo Excel. Puedes guardar esta configuración para utilizarla nuevamente.',
      format: {
        title: 'Formato de exportación',
        selectorLabel: 'Formato',
        selectorPlaceholder: 'Selecciona una opción',
        newOption: 'Nuevo formato',
        save: 'Guardar formato',
        saveAs: 'Guardar como',
        delete: 'Eliminar formato',
        saving: 'Guardando...',
        deleting: 'Eliminando...',
        nameLabel: 'Nombre del formato',
        namePlaceholder: 'Ej. Directorio comercial',
        nameRequired: 'Debes capturar el nombre del formato.',
        duplicateConfirm: 'Ya existe un formato con ese nombre. ¿Deseas reemplazarlo?',
        deleteConfirm: '¿Deseas eliminar este formato de exportación?',
        copySuffix: 'copia',
      },
      columns: {
        title: 'Columnas a exportar',
        subtitle: 'Activa las columnas que deseas incluir en el archivo. El orden de selección se respeta en el Excel.',
        selectAll: 'Todas',
        clearSelection: 'Limpiar',
        restoreDefault: 'Restaurar',
        selectedCount: (count) => `${count} columna${count === 1 ? '' : 's'} seleccionada${count === 1 ? '' : 's'}`,
        contactFallbackWarning: 'Para las columnas de persona de contacto se toma la información de la persona marcada como principal. Si no existe, se utiliza la primera disponible.',
        fiscalDefaultWarning: 'Los datos de facturación se toman del dato de facturación predeterminado del cliente.',
        orderTitle: 'Orden de columnas',
        orderSubtitle: 'Ajusta el orden con los controles de subir y bajar.',
        orderEmpty: 'No hay columnas seleccionadas.',
      },
      groups: {
        general: 'Información general',
        contact: 'Contacto y Persona de contacto',
        address: 'Dirección',
        fiscal: 'Información fiscal (dato de facturación)',
        classification: 'Clasificación',
        financial: 'Información financiera',
        commercial: 'Información comercial',
      },
      scope: {
        title: 'Alcance de la exportación',
        filtered: 'Resultado actual de filtros y búsqueda',
        pageCurrent: 'Clientes de la página actual',
        all: 'Todos los clientes',
      },
      footer: {
        cancel: 'Cancelar',
        saveAndExport: 'Guardar y exportar',
        exportOnly: 'Exportar',
        exporting: 'Exportando...',
      },
      toast: {
        loadError: 'No fue posible cargar la configuración de exportación.',
        noColumns: 'Debes seleccionar al menos una columna para exportar.',
        formatSaved: 'Formato de exportación guardado correctamente.',
        formatUpdated: 'Formato de exportación actualizado correctamente.',
        formatDeleted: 'Formato de exportación eliminado correctamente.',
        formatError: 'No fue posible guardar el formato de exportación.',
        formatDeleteError: 'No fue posible eliminar el formato de exportación.',
        exportSuccess: 'Exportación de clientes generada correctamente.',
        exportError: 'No fue posible exportar los clientes.',
      },
    },
    settings: {
      page: {
        title: 'Exportación',
        subtitle: 'Se muestran los formatos guardados para exportación de clientes.',
      },
      deleteModal: {
        title: 'Eliminar formato de exportación',
        subtitle: 'Confirma para continuar con esta operación.',
        message: (formatName) => `Formato: ${formatName}. ¿Deseas eliminar este formato de exportación? Esta acción no se puede deshacer.`,
        confirm: 'Eliminar',
      },
      table: {
        empty: 'No hay formatos de exportación registrados.',
        headers: {
          id: '#',
          name: 'FORMATO',
          module: 'MÓDULO',
          user: 'USUARIO',
          columns: 'COLUMNAS',
          updatedAt: 'ACTUALIZADO',
          actions: 'ACCIONES',
        },
        actions: {
          detail: 'Ver detalle',
          download: 'Descargar',
          delete: 'Eliminar',
        },
        moduleLabelByKey: {
          customers: 'Clientes',
          financial_accounts: 'Cuentas financieras',
        },
      },
      toast: {
        loadError: 'No fue posible consultar los formatos de exportación.',
      },
    },
  },
  imports: {
    history: {
      page: {
        title: 'Importaciones',
        subtitle: 'Historial de importaciones y reversión.',
      },
      filters: {
        statusLabel: 'Estado',
        statusPlaceholder: 'Filtrar por estado',
        options: {
          all: 'Todos los estados',
          validated: 'Validada',
          validationErrors: 'Errores de validación',
          imported: 'Importada',
          importedWithErrors: 'Importada con errores',
          reverted: 'Revertida',
        },
      },
      table: {
        empty: 'No hay importaciones registradas.',
        headers: {
          id: '#',
          folio: 'FOLIO',
          module: 'MÓDULO',
          status: 'ESTATUS',
          user: 'USUARIO',
          executedAt: 'EJECUTADA',
          document: 'DOCUMENTO',
          actions: 'ACCIONES',
        },
        actions: {
          detail: 'Ver detalle',
          downloadDocument: 'Descargar documento',
          rollback: 'Revertir',
          rollingBack: 'Revirtiendo...',
        },
        moduleLabelByKey: {
          customers: 'Clientes',
          'customers-billing': 'Clientes - Datos de facturación',
          'customers-people': 'Clientes - Personas',
          suppliers: 'Proveedores',
          invoices: 'Facturas',
          sales: 'Negocios',
          payments: 'Pagos',
          reports: 'Reportes',
        },
        statusLabelByKey: {
          validated: 'Validada',
          validation_errors: 'Errores de validación',
          imported: 'Importada',
          imported_with_errors: 'Importada con errores',
          reverted: 'Revertida',
        },
      },
      detail: {
        titlePrefix: 'Importación ',
        fileSummary: (rowsTotal, rowsCreated, rowsUpdated, rowsErrors) => `Filas: ${rowsTotal} | Creados: ${rowsCreated} | Actualizados: ${rowsUpdated} | Errores: ${rowsErrors}`,
        rowChangeLine: (rowNumber, action, entityLabel, entityId, entitySummary = '') => {
          const actionLabel = action === 'created' ? 'Creado' : (action === 'updated' ? 'Actualizado' : 'Procesado');
          const normalizedSummary = String(entitySummary || '').trim();
          if (normalizedSummary !== '') {
            return `Fila ${rowNumber}: ${actionLabel} ${entityLabel} - ${normalizedSummary}`;
          }

          const entityIdLabel = entityId > 0 ? ` #${entityId}` : '';
          return `Fila ${rowNumber}: ${actionLabel} ${entityLabel}${entityIdLabel}`;
        },
      },
      rollbackModal: {
        title: 'Revertir importación',
        subtitle: 'Confirma para continuar con esta operación.',
        expiredMessage: 'Esta importación ya no se puede revertir porque pasaron más de 24 horas desde su ejecución.',
        confirmMessage: 'Vas a revertir una importación ejecutada. Esta acción puede impactar información relacionada en el sistema.\n\nTe recomendamos continuar solo si ya revisaste el detalle y estás seguro de deshacer estos cambios.\n\n¿Deseas proseguir?',
        confirmButton: 'Sí, revertir',
        acknowledgeButton: 'Entendido',
      },
      toast: {
        historyError: 'No fue posible consultar el historial de importaciones.',
        detailError: 'No fue posible cargar el detalle de la importación.',
        downloadError: 'No fue posible descargar el documento de la importación.',
        rollbackSuccess: 'Importación revertida correctamente.',
        rollbackError: 'No fue posible revertir la importación.',
      },
    },
    modal: {
      title: 'Importar clientes',
      subtitle: 'Sube archivos independientes para Clientes, Datos de facturación y Personas.',
      sectionsTitle: 'Selecciona las secciones a importar',
      sectionsSubtitle: 'Puedes validar e importar una o varias secciones en el mismo batch.',
      sections: {
        customers: {
          title: 'Clientes',
          subtitle: 'Información general, contacto, clasificación, dirección y configuración financiera del cliente.',
        },
        billing: {
          title: 'Datos de facturación',
          subtitle: 'Información fiscal y domicilio para la facturación del cliente.',
        },
        people: {
          title: 'Personas',
          subtitle: 'Contactos del cliente y preferencias de envío.',
        },
      },
      upload: {
        title: 'Archivo a importar',
        subtitle: 'Carga el archivo para la sección seleccionada.',
        chooseFile: 'Seleccionar archivo',
        removeFile: 'Quitar archivo',
        empty: 'Ningún archivo seleccionado',
        formats: 'Formatos permitidos: .xls, .xlsx, .csv',
        sizeHint: 'Tamaño máximo sugerido: 10 MB',
      },
      instructions: {
        title: 'Ver instrucciones para importar',
        subtitle: 'Usa exactamente los encabezados de la plantilla y evita filas vacías intermedias.',
        bullets: [
          'Selecciona una sección por vez.',
          'Descarga la plantilla de la sección seleccionada.',
          'Completa los campos obligatorios y usa los opcionales solo cuando aplique.',
          'Valida antes de importar para revisar errores por fila y columna.',
        ],
        bySection: {
          customers: [
            'Campo obligatorio: nombre.',
            'Formato de fecha esperado: Fecha de ingreso en DD-MM-AAAA (ejemplo: 31-01-2026).',
            'Campos opcionales: Sitio web, Comentario, Email (correo válido), Teléfono, Teléfono adicional, Tipo de cliente, Tamaño, Sector, Origen, Área, Dirección, País, Estado, Ciudad, Código postal (5 dígitos) y Días de crédito (número entero).',
            'Si un campo opcional no aplica, déjalo vacío.',
          ],
          billing: [
            'Primero identifica al cliente con la columna Cliente. Ese nombre debe existir en tu listado de clientes.',
            'En Tipo de contribuyente escribe solo Nacional o Extranjero.',
            'Si es Nacional: completa RFC, Forma de pago y Método de pago.',
            'Si es Extranjero: usa el campo RFC como identificador fiscal (tal como venga en su país).',
            'También son obligatorios: Razón social, Código postal (5 dígitos), Régimen fiscal y Uso CFDI.',
            'Puedes capturar claves o nombres en catálogos. Ejemplos: Régimen fiscal 612, Uso CFDI G03, Forma de pago 03, Método de pago PUE.',
            'El resto de columnas son opcionales. Si las dejas vacías, no se borrará la información existente del cliente.',
          ],
          people: [
            'Los campos obligatorios son Cliente y Nombres.',
            'Usa Sí o No en: Recibe facturas, Recibe complementos de pago, Contacto de cobranza y Contacto principal.',
            'Si marcas Sí en Recibe facturas o Recibe complementos de pago, debes capturar un Email válido.',
            'Puedes completar datos opcionales como apellidos, puesto y teléfonos para tener mejor seguimiento del contacto.',
            'Si una columna opcional viene vacía, no se elimina la información que ya tenía ese contacto.',
          ],
        },
      },
      visualExample: {
        title: 'Ver ejemplo visual de la tabla esperada',
        subtitle: 'Esta tabla es una referencia visual y no es editable.',
      },
      validation: {
        title: 'Resultado de validación',
        importTitle: 'Resultado de importación',
        rowPrefix: 'Fila',
        validationInfo: (canImport, rowsInvalid, rowsWarnings) => {
          if (canImport) {
            const warningsLabel = rowsWarnings > 0
              ? ` Se detectaron ${rowsWarnings} advertencia${rowsWarnings === 1 ? '' : 's'} que no bloquean la importación.`
              : '';

            return `Validación completada correctamente. No se detectaron errores bloqueantes.${warningsLabel} Puedes continuar con la importación.`;
          }

          return `Validación completada con ${rowsInvalid} error${rowsInvalid === 1 ? '' : 'es'} bloqueante${rowsInvalid === 1 ? '' : 's'}. Corrige los registros marcados en la tabla para continuar.`;
        },
        importSuccessInfo: (rowsTotal, rowsCreated, rowsUpdated, rowsErrors, rowsWarnings) => `Importación completada. Se procesaron ${rowsTotal} fila${rowsTotal === 1 ? '' : 's'}: ${rowsCreated} creada${rowsCreated === 1 ? '' : 's'}, ${rowsUpdated} actualizada${rowsUpdated === 1 ? '' : 's'}, ${rowsErrors} con error y ${rowsWarnings} con advertencia.`,
        summary: {
          rowsTotal: 'Filas detectadas',
          rowsValid: 'Correctas',
          rowsInvalid: 'Errores',
          rowsWarnings: 'Advertencias',
          rowsProcessed: 'Total procesadas',
          rowsCreated: 'Registros creados',
          rowsUpdated: 'Registros actualizados',
        },
        table: {
          type: 'TIPO',
          row: 'FILA',
          column: 'COLUMNA',
          message: 'MENSAJE',
          empty: 'Sin errores para mostrar.',
        },
      },
      footer: {
        cancel: 'Cerrar',
        downloadTemplate: 'Descargar plantilla',
        validate: 'Validar',
        validating: 'Validando...',
        import: 'Importar',
        importing: 'Importando...',
      },
      toast: {
        templateError: 'No fue posible descargar la plantilla.',
        validateSuccess: 'Archivos validados correctamente.',
        validateError: 'No fue posible validar los archivos.',
        importSuccess: 'Importación ejecutada correctamente.',
        importError: 'No fue posible ejecutar la importación.',
      },
      sectionRequired: 'Debes seleccionar una sección.',
      fileRequired: 'Debes cargar un archivo para la sección seleccionada.',
      examples: {
        customers: {
          columns: [
            'Nombre',
            'Fecha de ingreso',
            'Sitio web',
            'Comentario',
            'Email',
            'Teléfono',
            'Teléfono adicional',
            'Tipo de cliente',
            'Tamaño',
            'Sector',
            'Origen',
            'Área',
            'Dirección',
            'País',
            'Estado',
            'Ciudad',
            'Código postal',
            'Días de crédito',
          ],
          row: [
            'ACME SA DE CV',
            '15-01-2026',
            'https://acme.com',
            'Cliente prioritario',
            'contacto@acme.com',
            '5555555555',
            '5512345678',
            'Cliente Regular',
            'Mediana',
            'Comercio',
            'Recomendación',
            'Ventas',
            'Av Reforma 100',
            'México',
            'Ciudad de México',
            'Ciudad de México',
            '06000',
            '30',
          ],
        },
        billing: {
          columns: [
            'Cliente',
            'Tipo de contribuyente',
            'RFC',
            'Razón social',
            'Código postal',
            'Régimen fiscal',
            'Uso CFDI',
            'Forma de pago',
            'Método de pago',
            'Calle',
            'No. exterior',
            'No. interior',
            'Colonia',
            'Municipio',
            'Estado',
            'País',
            'Cuenta de pago',
            'RFC banco beneficiario',
            'Banco ordenante',
            'RFC banco ordenante',
            'Cuenta ordenante',
          ],
          row: ['ACME SA DE CV', 'Nacional', 'XAXX010101000', 'ACME SA DE CV', '06000', '612', 'G03', '03', 'PUE', 'Av Reforma', '100', '10', 'Centro', 'Cuauhtémoc', 'Ciudad de México', 'México', '1234567890', 'XEXX010101000', 'Bank of America', 'XEXX010101000', '001122334455667788'],
        },
        people: {
          columns: [
            'Cliente',
            'Nombres',
            'Apellidos',
            'Puesto',
            'Email',
            'Teléfono de oficina',
            'Extensión',
            'Celular',
            'Teléfono de casa',
            'Teléfono adicional',
            'Dirección',
            'Ciudad',
            'Estado',
            'Código postal',
            'País',
            'Recibe facturas',
            'Recibe complementos de pago',
            'Contacto de cobranza',
            'Contacto principal',
          ],
          row: ['ACME SA DE CV', 'Juan', 'Pérez', 'Compras', 'juan@acme.com', '5555555555', '123', '5512345678', '', '', 'Av Reforma 100', 'Ciudad de México', 'Ciudad de México', '06000', 'México', 'Sí', 'No', 'No', 'No'],
        },
      },
    },
  },
  modal: {
    createTitle: 'Nuevo cliente',
    editTitle: 'Editar cliente',
    createSubtitle: 'Captura la información comercial, fiscal y financiera del cliente.',
    editSubtitle: 'Actualiza la información comercial, fiscal y financiera del cliente.',
    submitCreate: 'Guardar',
    submitEdit: 'Guardar cambios',
    sections: {
      general: {
        title: 'Información general',
        description: 'Identidad fiscal y comercial.',
      },
      contact: {
        title: 'Contacto',
        description: 'Canales de atención del cliente.',
      },
      classification: {
        title: 'Clasificación',
        description: 'Segmentos y prioridad de negocio.',
      },
      address: {
        title: 'Dirección',
        description: 'Ubicación fiscal y operativa.',
      },
      financial: {
        title: 'Configuración financiera',
        description: 'Pagos, crédito y facturación.',
      },
    },
    form: {
      general: {
        title: 'Información general',
        subtitle: 'Solo el campo Nombre es obligatorio para crear al cliente; el resto lo puedes completar después.',
        fields: {
          name: 'Nombre *',
          admissionDate: 'Fecha de ingreso',
          logo: 'Logo',
          logoPreviewAlt: 'Logo del cliente',
          website: 'Sitio web',
          status: 'Estado',
          active: 'Activo',
          inactive: 'Inactivo',
          comment: 'Comentario',
        },
        actions: {
          removeLogo: 'Quitar logo',
          selectLogo: 'Seleccionar archivo',
        },
        help: {
          logo: 'Sube una imagen para identificar al cliente.',
        },
        placeholders: {
          name: 'Nombre de la empresa',
          admissionDate: 'Selecciona fecha',
          logoEmpty: 'Ningún archivo seleccionado',
          website: 'https://empresa.com',
          comment: 'Comentario',
        },
        date: {
          nowLabel: 'Hoy',
        },
      },
      contact: {
        title: 'Contacto',
        subtitle: 'Persona responsable para seguimiento comercial y operativo.',
        fields: {
          email: 'Email',
          phone: 'Teléfono',
          additionalPhone: 'Teléfono adicional',
        },
        placeholders: {
          email: 'correo@empresa.com',
          phone: '(00) 0000-0000',
          additionalPhone: '(00) 0000-0000',
        },
      },
      classification: {
        title: 'Clasificación',
        subtitle: 'Atributos para segmentación, reporting y automatizaciones.',
        fields: {
          type: 'Tipo de cliente',
          size: 'Tamaño',
          sector: 'Sector',
          origin: 'Origen',
          area: 'Área',
        },
      },
      address: {
        title: 'Dirección',
        subtitle: 'Dirección fiscal y de contacto para documentos y operaciones.',
        fields: {
          useBillingAddress: 'Usar dirección de facturación',
          address: 'Dirección',
          country: 'País',
          state: 'Estado',
          city: 'Ciudad',
          zipCode: 'Código postal',
        },
        placeholders: {
          address: 'Dirección',
          country: 'Selecciona país',
          state: 'Selecciona estado',
          city: 'Ciudad',
          zipCode: 'Código postal',
        },
      },
      financial: {
        title: 'Configuración financiera',
        subtitle: 'Políticas de pago y parámetros de facturación.',
        fields: {
          creditDays: 'Días de crédito',
        },
        placeholders: {
          creditDays: '0',
        },
      },
    },
    validation: {
      nameRequired: 'El nombre es obligatorio',
      emailInvalid: 'Correo inválido',
    },
  },
  detail: {
    tabs: {
      summary: 'Resumen',
      information: 'Contacto y facturación',
      business: 'Negocios',
      finance: 'Finanzas',
      analysis: 'Análisis',
      documents: 'Documentos',
      settings: 'Opciones avanzadas',
      history: 'Historial',
    },
    subTabs: {
      business: {
        sales: 'Negocios',
        retainers: 'Igualas',
        multiCustomer: 'Multicliente',
      },
      finance: {
        all: 'Todos',
        invoices: 'Facturas',
        creditNotes: 'Notas de Crédito',
        simpleNotes: 'Notas Simples',
        payments: 'Pagos',
      },
      analysis: {
        accountStatement: 'Estado de Cuenta',
        cashFlow: 'Flujo de Efectivo',
      },
    },
    panel: {
      subSectionsAriaLabel: 'Subsecciones del cliente',
    },
    settingsTab: {
      title: 'Opciones avanzadas',
      description: 'Administra accesos y acciones críticas de este cliente.',
      cards: {
        permissions: {
          title: 'Permisos y visibilidad',
          description: 'Controla quién puede acceder a este cliente.',
          action: 'Configurar',
          statusLabel: 'Visibilidad actual',
          statusPublic: 'Público',
          statusPrivate: 'Privado',
          statusHidden: 'Oculto',
        },
        merge: {
          title: 'Fusionar cliente',
          description: 'Une este cliente con otro registro.',
          warning: 'Esta acción es irreversible.',
          action: 'Fusionar cliente',
        },
        archive: {
          title: 'Archivar cliente',
          description: 'Oculta el cliente sin eliminarlo.',
          action: 'Archivar',
        },
        unarchive: {
          title: 'Desarchivar cliente',
          description: 'Vuelve a mostrar el cliente para trabajar con él.',
          action: 'Desarchivar',
        },
        delete: {
          title: 'Eliminar cliente',
          description: 'Solo puede eliminarse un cliente que no tenga negocios o facturas relacionadas.',
          action: 'Eliminar',
        },
      },
    },
    visibilityModal: {
      title: 'Permisos y visibilidad',
      subtitle: 'Define cómo se comparte este cliente dentro de tu cuenta.',
      closeAriaLabel: 'Cerrar modal de visibilidad',
      options: {
        public: {
          title: 'Público',
          subtitle: 'Todos los usuarios de la cuenta pueden ver este cliente.',
        },
        private: {
          title: 'Privado',
          subtitle: 'Selecciona quién NO podrá ver este cliente.',
        },
        hidden: {
          title: 'Oculto',
          subtitle: 'Selecciona quién sí podrá ver este cliente.',
        },
      },
      usersSelectorPrivate: 'Selecciona quién no podrá ver este cliente',
      usersSelectorHidden: 'Selecciona quién podrá ver este cliente',
      usersPlaceholder: 'Selecciona usuarios',
      noUsers: 'Sin usuarios disponibles',
      publicNote: 'Este cliente será visible para todos los usuarios de la cuenta.',
      actions: {
        cancel: 'Cancelar',
        save: 'Guardar visibilidad',
        saving: 'Guardando...',
      },
    },
    mergeModal: {
      title: 'Fusionar clientes',
      subtitle: 'Unifica información y datos relacionados en un solo cliente.',
      closeAriaLabel: 'Cerrar modal de fusionar clientes',
      primaryCustomerLabel: 'Cliente principal',
      mergeWithLabel: 'Fusionar con',
      mergeWithPlaceholder: 'Selecciona cliente',
      mergeCustomerFallback: 'Cliente a fusionar',
      noOptions: 'Sin opciones disponibles',
      infoSectionTitle: 'Información',
      billingSectionTitle: 'Datos de facturación',
      contactsSectionTitle: 'Personas de contacto',
      relatedSectionTitle: 'Datos relacionados',
      billingWarning: 'Se unificarán los datos de facturación seleccionados. Si un dato ya fue utilizado en facturación no puede excluirse.',
      irreversibleWarning: 'La fusión conservará este cliente como principal y moverá la información seleccionada del cliente a fusionar. Revisa los campos, contactos y datos de facturación antes de confirmar.',
      confirmLabel: 'Para confirmar escribe "fusionar"',
      confirmPlaceholder: 'fusionar',
      emptyValue: 'vacio',
      tableHeaders: {
        field: 'Campo',
      },
      summaryLabels: {
        businesses: 'Negocios',
        payments: 'Pagos',
        invoices: 'Facturas',
        quotes: 'Cotizaciones',
      },
      actions: {
        cancel: 'Cancelar',
        submit: 'Fusionar',
        submitting: 'Procesando...',
      },
    },
    header: {
      actions: {
        editCustomer: 'Editar',
        newBusiness: 'Nuevo negocio',
        newRetainer: 'Nueva iguala',
        invoiceCustomer: 'Facturar',
      },
    },
    metrics: {
      totalForecast: 'Total pronóstico',
      totalBilled: 'Total facturado',
      lastInvoice: 'Última factura',
      lastInvoiceMetaPrefix: 'Fecha de creación:',
      lastInvoiceEmpty: 'SIN FACTURACIÓN',
      latestSale: 'Último negocio',
      latestSaleMetaPrefix: 'Fecha de creación:',
      emptyDash: '-',
    },
    overview: {
      health: {
        title: 'Salud del cliente',
        liquidity: 'LIQUIDEZ',
        collectedVsPending: 'Cobrado vs Pendiente',
        noForecastSummary: 'No hay datos de pronóstico para evaluar la salud financiera del cliente.',
        pendingSummary: (amount, percent) => `Pendiente por cobrar ${amount} (${percent}% del total pronosticado).`,
        exposureWarningTitle: 'Advertencia de exposición',
        exposureWarningText: (percent) => `El saldo pendiente representa ${percent}% del total pronosticado y supera el umbral recomendado de 15%.`,
        status: {
          risk: 'En riesgo',
          attention: 'Atención',
          healthy: 'Saludable',
        },
      },
      paymentFlow: {
        title: 'Flujo de pagos',
        totalPending: 'Total pendiente',
        overdue: 'Vencidos (+30d)',
        next7Days: 'Próximos 7 días',
        restOfMonth: 'Resto del mes',
      },
    },
    informationTab: {
      common: {
        assign: 'Asignar',
        noDate: 'Sin Fecha',
      },
      cards: {
        generalTitle: 'Información general',
        addressTitle: 'Dirección',
        commentsTitle: 'Comentarios',
      },
      actions: {
        editGeneral: 'Editar información general',
        editAddress: 'Editar dirección',
        editComments: 'Editar comentarios',
      },
      labels: {
        general: {
          name: 'Nombre',
          sinceDate: 'Fecha de ingreso',
          website: 'Sitio web',
          status: 'Estado',
          email: 'Email',
          phone: 'Teléfono',
          additionalPhone: 'Teléfono adicional',
        },
        billing: {
          fiscalName: 'Razón social',
          rfc: 'RFC',
          cfdiUse: 'Uso CFDI',
          fiscalRegime: 'Régimen fiscal',
          paymentMethod: 'Forma de pago',
          paymentMethodType: 'Método de pago',
          fiscalResidence: 'Residencia fiscal',
        },
        address: {
          address: 'Dirección',
          country: 'País',
          state: 'Estado',
          city: 'Ciudad',
          zipCode: 'Código postal',
        },
      },
      comments: {
        empty: 'Sin comentarios',
      },
      contactRoles: {
        quoteBilling: 'Cotización/Facturación',
        paymentComplements: 'Complementos de pago',
        collections: 'Cobranza',
        noRole: 'Sin rol',
      },
    },
    generalMethods: {
      newBusinessPending: 'Nuevo negocio estará disponible pronto.',
      businessCreateSuccess: 'El negocio ha sido registrado correctamente.',
      businessCreateError: 'No fue posible registrar el negocio.',
      newRetainerPending: 'Nueva iguala estará disponible pronto.',
      retainerCreateSuccess: 'La iguala ha sido registrada correctamente.',
      retainerCreateError: 'No fue posible registrar la iguala.',
      invoicePending: 'Facturar estará disponible pronto.',
      invoiceBillingDataRequired: 'Debes dar de alta los datos de facturación del cliente para poder facturar.',
      saleDetailByName: (saleName) => `Detalle de negocio: ${saleName}.`,
      saleDetailPending: 'Detalle de negocio estará disponible pronto.',
      saleStatusChangeByName: (saleName) => `Cambio de estado para ${saleName} estará disponible pronto.`,
      saleStatusChangePending: 'Cambio de estado de negocio estará disponible pronto.',
      customerUpdateSuccess: 'Cliente actualizado correctamente.',
      customerUpdateError: 'No fue posible actualizar el cliente.',
      customerVisibilityUpdateSuccess: 'Visibilidad del cliente actualizada correctamente.',
      customerVisibilityUpdateError: 'No fue posible actualizar la visibilidad del cliente.',
      customerArchiveSuccess: 'Cliente archivado correctamente.',
      customerArchiveError: 'No fue posible archivar el cliente.',
      customerUnarchiveSuccess: 'Cliente desarchivado correctamente.',
      customerUnarchiveError: 'No fue posible desarchivar el cliente.',
      customerAdvancedPermissionsPending: 'Configuración de permisos y visibilidad estará disponible pronto.',
      customerMergeSuccess: 'Cliente fusionado correctamente.',
      customerMergeError: 'No fue posible fusionar el cliente.',
      invalidCustomer: 'Cliente inválido.',
      loadDetailError: 'No fue posible cargar el detalle del cliente.',
    },
    advancedOptionsConfirm: {
      archive: {
        title: 'Archivar cliente',
        subtitle: 'Confirma para continuar con esta operación.',
        message: (customerName) => `Cliente: ${customerName}. ¿Deseas archivarlo? Podrás desarchivarlo después.`,
        confirm: 'Archivar',
      },
      unarchive: {
        title: 'Desarchivar cliente',
        subtitle: 'Confirma para continuar con esta operación.',
        message: (customerName) => `Cliente: ${customerName}. ¿Deseas desarchivarlo? Volverá a mostrarse como activo.`,
        confirm: 'Desarchivar',
      },
    },
  },
  history: {
    title: 'Historial del cliente',
    subtitle: 'Registro cronológico de movimientos y cambios del cliente.',
    loading: 'Cargando historial del cliente...',
    empty: 'Sin movimientos registrados en el historial.',
    table: {
      headers: {
        index: '#',
        date: 'Fecha',
        module: 'Módulo',
        event: 'Evento',
        description: 'Descripción',
        user: 'Usuario',
      },
    },
    fallback: {
      date: '-',
      module: 'General',
      event: 'Cambio',
      description: 'Actividad registrada',
      actor: 'Sistema',
    },
  },
});
